import { ref } from "vue";
import { PlayerStore } from "@/front/stores/player_store.js";
import { VideoStore } from "@/front/stores/video_store.js";
import { firstValidValue } from "@/front/composables/GeneralHelper";
export function PositionCalculator() {
  const playerStore = PlayerStore();
  const videoStore = VideoStore();
  function calculatePosition(ann) {
    if (!videoStore.video.id) {
      return {}
    }
    if (!ann) return {}
    const customStyle = ann.customStyle && JSON.parse(ann.customStyle) || {}
    var layerWidth = playerStore.layerDimensions.width
    var layerHeight = playerStore.layerDimensions.height
    // const aspectRatio = ann.aspect_ratio || ann.aspectRatio || 1.77
    const aspectRatio = 1

    let coverModeMultiplier = 1
    if (videoStore.video.design.cover_mode && playerStore.videoElement) {
      const videoTrueRatio = playerStore.videoElement?.videoWidth / playerStore.videoElement?.videoHeight
      const screenRatio = playerStore.playerState.width / playerStore.playerState.height
      coverModeMultiplier = videoTrueRatio / screenRatio
      if (isNaN(coverModeMultiplier)) {
        coverModeMultiplier = 1
      }
    }
    const at = firstValidValue(ann.pos_top, customStyle.top, 33) / coverModeMultiplier
    const al = firstValidValue(ann.pos_left, customStyle.left, 33)
    const aw = firstValidValue(ann.pos_width, customStyle.width, 33) 
    const ah = firstValidValue(ann.pos_height, customStyle.height, 33) / coverModeMultiplier


    // log.info(3,"🔎 PositionCalculator calculatePosition T/L/W/H", ann.type_of, at, al, aw, ah)
    
    // Calculate width and height while preserving aspect ratio for images
    let width, height
    if (ann.type_of === 'image' && ann.aspect_ratio && !ann.full_screen) {
      // For images, calculate dimensions based on aspect ratio
      width = aw * 0.01 * layerWidth
      height = width / aspectRatio
      
      // If height exceeds bounds, recalculate based on height
      if (height > layerHeight * (ann.pos_height * 0.01)) {
        height = ah * 0.01 * layerHeight
        width = height * aspectRatio
      }
    } else if (ann.type_of === 'video' && ann.aspect_ratio) {
      // For images, calculate dimensions based on aspect ratio
      width = aw * 0.01 * layerWidth
      height = width / aspectRatio
      
      // If height exceeds bounds, recalculate based on height
      if (height > layerHeight * (ann.pos_height * 0.01)) {
        height = ah * 0.01 * layerHeight
        width = height * aspectRatio
      }
    } else {
      // For non-images, use standard calculation
      width = aw * 0.01 * layerWidth
      height = ah * 0.01 * layerHeight
    }
  
    const left = al * 0.01 * layerWidth
    const top = at * 0.01 * layerHeight

    // Get reference width with fallback to 1920 for standard HD
    const referenceWidth = ann.og_video_width || customStyle.videoWidth || 1920
    const widthRatio = layerWidth / referenceWidth

    // Downscale font slightly on smaller screens to ensure doesn't run out
    // OldStamp used aggressive 0.95 and 0.9 multis for desktop / mobile, scaling them down even further
    const baseFontSize = ann.font_size || Number(customStyle.fontSize) || 12
    const fontSize = baseFontSize * widthRatio * 0.8

    // Use more appropriate line-height at larger sizes to prevent text overlap
    // 1.1em was too tight and caused characters/lines to overlap at large font sizes
    let lineHeight
    if (fontSize > 60) {
      lineHeight = '1.35em' // Very large text needs more space
    } else if (fontSize > 40) {
      lineHeight = '1.3em' // Large text needs some extra space
    } else if (fontSize > 20) {
      lineHeight = '1.25em' // Medium text
    } else {
      lineHeight = '1.2em' // Small text
    }

    let result = {
      width: Number(width.toFixed(2)),
      height: Number(height.toFixed(2)),
      minHeight: Number(Math.max(height, fontSize).toFixed(2)),
      left: Number(left.toFixed(2)),
      top: Number(top.toFixed(2)),
      fontSize: Number(fontSize.toFixed(2)),
      lineHeight: lineHeight,
    }
    // log.info(3,"🔎 PositionCalculator calculatePosition result", result)
    return result
  }

  function getWidthRatio(ann) {
    const customStyle = ann.customStyle && JSON.parse(ann.customStyle) || {}
    let result = playerStore.layerDimensions.width / (ann.og_video_width || customStyle.videoWidth)
    log.info(2,"🔎 PositionCalculator getWidthRatio", result, playerStore.layerDimensions.width, ann.og_video_width, customStyle.videoWidth)
    return result
  }

  function pxToWidthPercent(px) {
    return Number((px / playerStore.layerDimensions.width * 100).toFixed(2))
  }

  function pxToHeightPercent(px) {
    return Number((px / playerStore.layerDimensions.height * 100).toFixed(2))
  }

  function getRelativeLayerDimensions(top,left,width,height) {
    return {
      top: playerStore.layerDimensions.top  + (top/100) * playerStore.layerDimensions.height + 'px',
      left: playerStore.layerDimensions.left + (left/100) * playerStore.layerDimensions.width + 'px',
      width: playerStore.layerDimensions.width * (width/100) + 'px',
      height: playerStore.layerDimensions.height * (height/100) + 'px',
    }
  }


  return { calculatePosition, getWidthRatio, pxToWidthPercent, pxToHeightPercent, getRelativeLayerDimensions };
}